import { FC, useEffect, useState, useRef } from 'react';
import { Switch, Popover } from 'antd-mobile';
import { useNavigate } from 'react-router-dom';
import { setStorage } from '@/utils';
import { getToken, Login } from '@/helper/user';
import pageVisibility from '@/utils/pageVisibility';
import {
  enableNotification,
  openNotificationSetting,
  HUser,
  isAndroid,
} from '@haidilao-private/jsbridge';
import './index.scss';
import SignInExplain from './components/SignInExplain';
import SignInSuccess from './components/SignInSuccess';
import SignInRemind from './components/SignInRemind';
import SignInClose from './components/SignInClose';
import SignInOverdue from './components/SignInOverdue';
import SignInCountDown from './components/SignInCountDown';
import SignInItem from './components/SignInItem';
import Share from '@/components/Share';
import Loading from '@/components/Loading';
import { getPosition, ToggleRemined } from './config';
import HdlToast from '@/utils/toast';
import { isEnv, setDocumentTitle } from '@/utils';
import { LoginPath, DownloadPath } from '@/helper/common/common';
import Apis from '@/api';
import { TOKEN_KEY } from '@/helper/common/constant';
import HHeader from '@/components/HHeader';
import { headerInitProps } from '@/helper/common/interface';
const {
  getSigninQuery,
  queryFragment,
  querySite,
  querySwitch,
  switchSignin,
  signin,
} = Apis.signIn;

// images
import rightContentWhite from '@/images/header/icon_share_white.png';
import rightContentBlack from '@/images/header/icon_share_black.png';

const Index: FC = () => {
  const navigate = useNavigate();
  // const params = useParams();
  const explainRef = useRef<any>(); //活动说明
  const successRef = useRef<any>(); //签到成功
  const remindRef = useRef<any>(); //提醒弹框
  const closeRef = useRef<any>(); //关闭提醒弹框
  const overdueRef = useRef<any>(); //过期提醒
  const shareRef = useRef<any>(); //分享
  const loadingRef = useRef<any>(); //loading
  const isApp = isEnv() === 'App';
  // 设置tip的body体
  const popoverBody0 = useRef<any>();
  const popoverBody1 = useRef<any>();
  const popoverBody2 = useRef<any>();
  const popoverBody3 = useRef<any>();
  const popoverBody4 = useRef<any>();
  const popoverBody5 = useRef<any>();
  const popoverBody6 = useRef<any>();
  const popoverBodyList = [
    popoverBody0,
    popoverBody1,
    popoverBody2,
    popoverBody3,
    popoverBody4,
    popoverBody5,
    popoverBody6,
  ];
  const [checked, setChecked] = useState<boolean>(false); //1开  0关
  const [signinInfo, setSigninInfo] = useState<any>(null); //查询签到信息
  const [signinInfoToday, setSigninInfoToday] = useState<any>(null); //今日查询签到信息
  const [fragment, setFragment] = useState<any>(null); //查询碎片
  const [site, setSite] = useState<any>(null); //查询碎片兑换地址
  const [successData, setSuccessData] = useState<any>(null); //签到成功弹框
  const [shareUrl, setShareUrl] = useState<string>(''); //分享地址
  const [isSignIn, setIsSignIn] = useState<boolean>(true); //是否可点击
  const [headerConfig, setHeaderConfig] = useState<headerInitProps>({
    rightContent: <img src={rightContentWhite} alt="返回" />,
    rightClick: () => {
      shareRef.current.open();
    },
    theme: 'black',
    title: '',
    isHeader: true,
    className: 'signin-header-custom',
  });
  /**
   * @description:
   * @param {*}
   * @return {*}
   */
  const goToEnd = (err: any) => {
    const {
      data: { code },
    } = err;
    if (code === '-1') navigate('/error/activeEnd', { replace: true });
  };
  /**
   * @description: 立即签到
   * @param {*}
   * @return {*}
   */
  const goSignIn = async () => {
    try {
      if (!isSignIn) {
        return;
      }
      setIsSignIn(false);
      //已签到
      if (signinInfo.signinOr === 1) {
        return;
      }
      const res = await signin({
        signinSource: isEnv(),
      });
      setSuccessData(res);
      //刷新页面数据
      successRef.current.open();
      getSigninModule();
      getFragment();
    } catch (err: any) {
      goToEnd(err);
      successRef.current.close();
    } finally {
      setIsSignIn(true);
    }
  };
  /**
   * @description: header 气泡展示
   */
  const getBubble = () => {
    if (!signinInfoToday) return null;
    const {
      dishesCount: dishesTotal,
      fragment,
      fragmentSeries,
      growth,
      growthSeries,
      dailySigninStatus,
    } = signinInfoToday;
    const { seriesState } = signinInfo;
    const bubbleArr: Array<object> = [];
    const size: Array<string> = ['big', 'small', 'mini'];
    if (dailySigninStatus === 2) {
      //已签到
      return <div className={`header__bubble-big signin`}></div>;
    }
    const fragmentTotal: number =
      seriesState === 1 ? fragment + fragmentSeries || 0 : fragment;
    const growthTotal: number =
      seriesState === 1 ? growth + growthSeries || 0 : growth;
    //碎片
    fragmentTotal > 0 &&
      bubbleArr.push({
        classname: 'fragmen',
        num: fragmentTotal,
      });
    // 成长值
    growthTotal > 0 &&
      bubbleArr.push({
        classname: 'money',
        num: growthTotal,
      });
    // 惊喜菜品
    dishesTotal > 0 &&
      bubbleArr.push({
        classname: 'gift',
        num: dishesTotal,
      });
    if (bubbleArr.length > 0) {
      return (
        <>
          {bubbleArr.map((el: any, index: number) => (
            <div
              className={`header__bubble-${size[index]} ${el.classname}`}
              key={index}
              onClick={goSignIn}
            >
              {
                // 最后一个惊喜菜品不展示数量
                el.classname !== 'gift' && (
                  <>
                    +<span>{el.num}</span>
                  </>
                )
              }
            </div>
          ))}
        </>
      );
    }
    return null;
  };
  /**
   * @description: 活动说明
   */
  const openExplain = async () => {
    explainRef.current.open();
  };
  /**
   * @description: switch开关 提醒
   */
  const onChange = async (checked: boolean) => {
    if (!checked) {
      closeRef.current.open();
      return false;
    }
    remindRef.current.open(); //碎片提醒弹框
  };
  /**
   * @description: 关闭/开启 提醒
   * type close 关闭   open 开启
   * closeMsg 关闭提示文案
   * needRemined 是否需要提醒弹款 true 需要 false不需要
   * needApi 是否需要调借口 true 需要 false不需要
   */
  const toggleRemined = async ({
    type,
    needRemined,
    closeMsg,
    needApi,
  }: ToggleRemined) => {
    try {
      needApi && (await switchSignin());
      if (type === 'close') {
        HdlToast.info(
          closeMsg ? closeMsg : '开启失败,您未开启海底捞APP通知权限',
        );
        setChecked(false);
      } else {
        //yes
        needRemined && remindRef.current.open(); //碎片提醒弹框
        setChecked(true);
        //查询通知状态
        enableNotification((res: any) => {
          // 返回： 0 代表未开启 1 代表开启
          if (res === 0) {
            openNotificationSetting();
          } else {
            HdlToast.info('开启成功,将在每日11:00提醒您签到');
          }
        });
      }
      closeModal();
    } catch (err: any) {
      goToEnd(err);
    }
  };
  /**
   * @description: 关闭弹框
   */
  const closeModal = () => {
    remindRef.current.close();
    successRef.current.close();
    closeRef.current.close();
  };
  /**
   * @description: 跳转我的碎片
   */
  const goFragment = () => {
    navigate('/signInFragment');
  };
  /**
   * @description: 即将上线提示
   * type convertUrl 碎片商店  lotteryUrl 抽奖地址 mask任务
   */
  const navTime = useRef<number>(0);
  const getTime = () => new Date().getTime();
  const openUrl = async (type?: string) => {
    if (getTime() - navTime.current <= 300) return;
    navTime.current = getTime();
    if (type && site[type]) {
      if (type === 'convertUrl' && isEnv() !== 'App') {
        if (isEnv() === 'MiniApp') {
          const urlarr = (site[type] as string).split('/');
          window.wx.miniProgram.navigateTo({
            url:
              '/activePackage/pages/convertPrize/shop/shop?activeId=' +
              urlarr[urlarr.length - 1],
          });
          return;
        } else if (isEnv() === 'alipay') {
          const urlarr = (site[type] as string).split('/');
          window.my.navigateTo({
            url:
              '/activePackage/pages/convertPrize/shop/shop?activeId=' +
              urlarr[urlarr.length - 1],
          });
          return;
        } else {
          //跳转碎片商店需要保存token
          const token = await getToken();
          setStorage(TOKEN_KEY, token);
        }
      }
      location.href = `${site[type]}${
        type === 'convertUrl' ? `?tokenName=${TOKEN_KEY}` : ''
      }`;
      return;
    }
    //h5下面 点击做任务 跳转下载页面
    if (type === 'mask' && isEnv() === 'H5') {
      location.href = DownloadPath(site.activityNameTitle);
      return;
    }
    HdlToast.info('功能即将上线，敬请期待');
  };
  /**
   * @description: 获取页面滚动高度
   */
  const getScrollTop = () => {
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    // 监听scrollTop
    let theme = '',
      rightContent = '';
    if (scrollTop > 20) {
      theme = 'white';
      rightContent = rightContentBlack;
    } else {
      theme = 'black';
      rightContent = rightContentWhite;
    }
    setHeaderConfig((headerConfig) => ({
      ...headerConfig,
      rightContent: <img src={rightContent} alt="返回" />,
      theme,
    }));
  };
  /**
   * @description: 查询签到信息
   */
  const getSigninModule = async () => {
    try {
      const res: any = await getSigninQuery();
      setSigninInfo(res);
      setSigninInfoToday(
        res.signinQueryDetailList.find((e: any) => e.currentOr === 1),
      ); //找到今日模块 放置顶部气泡中
    } catch (err: any) {
      goToEnd(err);
    } finally {
      loadingRef.current.close();
    }
  };
  /**
   * @description: 查询碎片数量
   */
  const getFragment = async () => {
    try {
      const res: any = await queryFragment();
      setFragment(res);
      res.reminder === 1 && overdueRef.current.open(); //碎片过期弹框
    } catch (err: any) {
      goToEnd(err);
      loadingRef.current.close();
    }
  };
  /**
   * @description: 查询碎片兑换地址
   */
  const getSite = async () => {
    try {
      const res: any = await querySite();
      setSite(res);
      setDocumentTitle(res.activityNameTitle);
      setShareUrl(
        LoginPath(
          `${location.origin}${
            location.pathname
          }?source=H5#/signIndex/${new Date().getTime()}`,
          '签到享好礼',
        ),
      );
      //设置header title
      setHeaderConfig((headerConfig) => ({
        ...headerConfig,
        title: res.activityNameTitle,
      }));
    } catch (err: any) {
      goToEnd(err);
      loadingRef.current.close();
    }
  };
  /**
   * @description: 查询签到开关状态
   */
  const getSwitchStatus = async () => {
    try {
      const res: any = await querySwitch(); //1开  0关
      const checked = Boolean(res);
      setChecked(checked);
    } catch (err: any) {
      goToEnd(err);
      loadingRef.current.close();
    }
  };
  /**
   * @description: 获取tips弹框内容
   */
  const getContent = (item: any) => {
    const {
      fragmentSeries,
      growthSeries,
      daysSeries,
      dishesKey,
      dishesCount,
      dishesSeriesOr,
    } = item;
    const { seriesState } = signinInfo;
    let content: any = null;
    let X = '';
    const N = daysSeries;
    if (fragmentSeries > 0) X += `${X ? '、' : ''}碎片+${fragmentSeries}`;
    if (growthSeries > 0) X += `${X ? '、' : ''}成长值+${growthSeries}`;
    if (dishesCount > 0 && dishesSeriesOr === 1) {
      X += `${X ? '、' : ''}${dishesKey}x${dishesCount}`;
    }
    if (seriesState === 1) {
      //连签
      content = (
        <>
          奖品{X}是连签专属奖，是从每7日周期的第1天开始
          <span className="signin__popover__light">连签{N}天</span>
          额外获得的。请继续保持签到呀~
        </>
      );
    } else {
      //未连签
      content = (
        <>
          奖品{X}是连签专属奖，只有从每个7日独立周期的第1天开始
          <span className="signin__popover__light">连签{N}天</span>
          才能额外获得。别灰心，每个独立周期都会有连签奖，记得来~
        </>
      );
    }
    return content;
  };
  /**
   * @description:
   * @param {*}
   * @return {*}
   */
  const toDoReload = () => {
    console.log('倒计时结束');
  };
  /**
   * @description: 是否展示popover
   * @param {*}
   * @return {*}
   */
  const isShowPopover = (item: any) => {
    const { fragmentSeries, growthSeries, dishesCount, dishesSeriesOr } = item;
    return (
      item.dailySigninStatus !== 1 &&
      (fragmentSeries > 0 ||
        growthSeries > 0 ||
        (dishesSeriesOr === 1 && dishesCount > 0))
    );
  };
  /**
   * @description: 初始化页面
   */
  const initPage = () => {
    if (isApp) {
      HUser.getUserInfo((res: any) => {
        if (res && res.token) {
          getSite();
          getSigninModule();
          getFragment();
          getSwitchStatus();
        } else {
          isAndroid && Login(); //如果取不到ios会自动吊起来登录
        }
      });
    } else {
      getSite();
      getSigninModule();
      getFragment();
      getSwitchStatus();
    }
  };
  useEffect(() => {
    loadingRef.current.open(); //打开loading
    window.scroll(0, 0); //滚动至最顶部
    window.addEventListener('scroll', getScrollTop);
    initPage();
    // 清除监听
    return () => {
      window.removeEventListener('scroll', getScrollTop);
      HdlToast.clear();
    };
  }, []);
  useEffect(() => {
    const reloadPage = () => {
      if (!pageVisibility.hidden()) {
        loadingRef.current.open(); //打开loading
        initPage();
      }
    };
    pageVisibility.visibilitychange(reloadPage);
    // 清除监听
    return () => {
      pageVisibility.destory(reloadPage);
    };
  });

  return (
    <div className={`signin ${isApp ? '' : 'no-header'}`}>
      {isApp && <HHeader custom={headerConfig} />}
      <SignInExplain cRef={explainRef} />
      <SignInSuccess
        cRef={successRef}
        datas={successData}
        checked={checked}
        openRemined={toggleRemined}
        seriesState={signinInfo && signinInfo.seriesState}
      />
      <SignInRemind cRef={remindRef} openRemined={toggleRemined} />
      <SignInClose cRef={closeRef} closeRemined={toggleRemined} />
      <SignInOverdue cRef={overdueRef} total={fragment && fragment.total} />
      <Share
        cRef={shareRef}
        shareUrl={shareUrl}
        image="https://hdl-middletier-prd.oss-cn-beijing.aliyuncs.com/app-img/icon.png"
      />
      <Loading cRef={loadingRef} />
      <div className="signin__header">
        {/* 悬浮奖励 */}
        {getBubble()}
        {/* 活动说明 */}
        <div className="header__explain" onClick={openExplain}></div>
        {/* 我的碎片 */}
        <div className="header__my-bubble">
          <img src={require('@/images/signIn/my_fragment.png')} alt="" />
          <p>{fragment && fragment.total}</p>
        </div>
        {/* <p className='header__overdue'>本期碎片将于 2021-12-28 到期</p> */}
        {/* 过期提醒 */}
        <div className="header__overdue">
          <SignInCountDown datas={fragment} reload={toDoReload} />
        </div>
        <div className="header__btn_bubble" onClick={goFragment}></div>
      </div>
      {/* 签到 */}
      <div className="signin__body">
        <div className="signin__body__header">
          {signinInfo && signinInfo.seriesOr === 1 ? (
            // 连续签到
            <div className="signin__body__header__continuity">
              <img
                src={require('@/images/signIn/bg_title_continue.png')}
                alt=""
                className="signin__body__header__img1"
              />
              <img
                src={require(`@/images/signIn/num${signinInfo.seriesDays}.png`)}
                alt=""
                className="signin__body__header__img2"
              />
              <img
                src={require('@/images/signIn/bg_title_continue_cell.png')}
                alt=""
                className="signin__body__header__img3"
              />
            </div>
          ) : (
            // 未连续签到
            <img
              src={require('@/images/signIn/bg_title_leak.png')}
              alt=""
              className="signin__body__header__leak"
            />
          )}
          {isApp && (
            <div className="signin__body__header__txtbox">
              <span className="signin__body__header__txt">签到提醒</span>
              <Switch
                checked={checked}
                onChange={onChange}
                style={{
                  '--checked-color': '#DE474B',
                  '--height': '16Px',
                  '--width': '28Px',
                }}
              />
            </div>
          )}
        </div>
        <div className="signin__body__list">
          {signinInfo &&
            signinInfo.signinQueryDetailList.map((item: any, index: number) => (
              <div
                className={`signin__popover signin__body__list${index}`}
                key={index}
                ref={popoverBodyList[index]}
              >
                {isShowPopover(item) ? (
                  <Popover
                    content={getContent(item)}
                    placement={getPosition(index)}
                    mode="dark"
                    trigger="click"
                    getContainer={() => popoverBodyList[index].current}
                    destroyOnHide={false}
                  >
                    <div>
                      <SignInItem
                        item={item}
                        index={index}
                        seriesState={signinInfo && signinInfo.seriesState}
                      />
                    </div>
                  </Popover>
                ) : (
                  <SignInItem
                    item={item}
                    index={index}
                    seriesState={signinInfo && signinInfo.seriesState}
                  />
                )}
              </div>
            ))}
        </div>
        <div className="signin__body__btn">
          <img
            src={require(`@/images/signIn/${
              signinInfo && signinInfo.signinOr === 1
                ? 'btn_signin_alerady'
                : 'btn_signin'
            }.png`)}
            alt="签到按钮"
            onClick={goSignIn}
          />
        </div>
      </div>
      {/* 活动模块 */}
      <div className="signin__active">
        <div className="signin__active__top">
          <img
            src={require('@/images/signIn/bg_active1.png')}
            alt=""
            onClick={() => openUrl('convertUrl')}
          />
          <img
            src={require('@/images/signIn/bg_active2.png')}
            alt=""
            onClick={() => openUrl('lotteryUrl')}
          />
        </div>
        <img
          src={require('@/images/signIn/bg_active3.png')}
          alt=""
          className="signin__active__bottom"
          onClick={() => openUrl('mask')}
        />
      </div>
    </div>
  );
};

export default Index;
